// PureDaArrearsPDF.jsx
import React, { useMemo } from 'react';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

// Use your current styles here (unchanged)
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 10,
    marginTop: 10,
  },
  header: {
    marginTop: 8,
    marginBottom: 1,
    borderBottom: 2,
    marginLeft: 20,
    marginRight: 20,
    borderBottomColor: '#000000',
    paddingBottom: 1,
    textAlign: 'center',
  },
  Office: {
    fontSize: 14,
    fontStyle: 'Bold',
  },
  Info: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  specialNote: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    textAlign: 'right',
  },
  specialNoteLabel: {
    fontWeight: 'bold',
    marginRight: 4,
    fontSize: 6,
  },
  specialNoteText: {
    fontSize: 6,
  },
  employeeInfo: {
    flexDirection: 'row',
    marginBottom: 1,
    flexWrap: 'wrap',
    fontSize: 8,
    marginTop: 3,
    gap: 15,
  },
  employeeName: {},
  periodInfo: {
    backgroundColor: '#f7fafc',
    padding: 5,
    marginBottom: 1,
    fontSize: 8,
  },
  Designation: {},
  payLevel: {
    fontSize: 8,
    flexDirection: 'row',
    gap: 200,
  },
  table: {
    display: 'table',
    width: '95%',
    marginBottom: 20,
    fontSize: 8,
    alignSelf: 'center',
    borderLeft: 1,
    borderRight: 1,
    borderBottom: 1,
  },
  tableHeader: {
    backgroundColor: '#bcbcbc',
    color: '#000000',
    justifyContent: 'flex',
    borderBottomWidth: 2,
    borderBottomColor: '#000000',
    fontWeight: 600,
  },
  tableSubHeader: {
    backgroundColor: '#f7fafc',
    borderBottomWidth: 1,
    borderBottomColor: '#000000',
    height: 20,
    fontWeight: 500,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#000000',
    height: 15,
  },
  tableCell: {
    padding: 1,
    fontSize: 6,
    textAlign: 'center',
    flex: 1,
    justifyContent: 'center',
    minWidth: 1,
    wordWrap: 'break-word',
    borderRightWidth: 1,
    borderRightColor: '#000000',
  },
  tableCellHeader: {
    fontWeight: 'bold',
    fontSize: 6,
    color: '#000000',
    textAlign: 'center',
    justifyContent: 'center',
  },
  tableCellSubHeader: {
    fontWeight: 'bold',
    fontSize: 6,
    color: '#000000',
    wordWrap: 'break-word',
  },
  sectionHeader: {
    backgroundColor: '#000000',
    padding: 1,
  },
  sectionHeaderText: {
    color: '#ffffff',
    fontSize: 10,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  tableCellCustomWidth: {
    width: 30,
    padding: 1,
    fontSize: 6,
    justifyContent: 'center',
    textAlign: 'center',
    borderRightWidth: 1,
    borderRightColor: '#000000',
  },
  tableCellSrNo: {
    width: 20,
    padding: 1,
    fontSize: 6,
    justifyContent: 'center',
    textAlign: 'center',
    borderRightWidth: 1,
    borderRightColor: '#000000',
  },
  lastRow: {
    fontWeight: 'bold',
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 30,
    right: 30,
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderTopWidth: 1,
    borderTopColor: '#000000',
    paddingTop: 10,
  },
  pageNumber: {
    fontSize: 6,
    color: '#000000',
  },
  dateText: {
    fontSize: 6,
    color: '#000000',
  },
  Himanshu: {
    textAlign: 'center',
    fontSize: 6,
  },
});

const PureDaArrearsPDF = ({ result, info }) => {
  const itemsPerPage = 40;
  const totalPages = useMemo(() => Math.ceil(result.length / itemsPerPage), [result, itemsPerPage]);

  return (
    <Document>
      {Array.from({ length: totalPages }).map((_, pageIndex) => (
        <Page key={pageIndex} size="A4" orientation="landscape" style={styles.page}>
          {/* Header Section */}
          <View style={styles.header}>
            <View style={styles.Office}>
              <Text>{info.officeName}</Text>
            </View>
            <View style={styles.periodInfo}>
              <Text style={styles.periodText}>
                Statement showing the difference of D.A. & H.R.A. payable due to revision of D.A. Rates for the period: 01/07/2024 to {info.arrearsEndDate}
              </Text>
            </View>
            <View style={styles.Info}>
              <View>
                <View style={styles.employeeInfo}>
                  <View style={styles.employeeName}>
                    <Text>Employee Name: {info.employeeName}</Text>
                  </View>
                  <View style={styles.Designation}>
                    <Text>Designation: {info.designation}</Text>
                  </View>
                </View>
                <View style={styles.payLevel}>
                  <View>
                    <Text>Due Pay Level/s: {info.payLevel}</Text>
                  </View>
                  <View style={styles.drawnPayLevel}>
                    <Text>Drawn Pay Level/s: {info.payLevel}</Text>
                  </View>
                </View>
              </View>
              <View style={styles.specialNote}>
                <Text style={styles.specialNoteLabel}>Special Note:</Text>
                <Text style={styles.specialNoteText}>{info.specialNote || '--'}</Text>
              </View>
            </View>
          </View>

          {/* Table Section */}
          <View style={styles.table}>
            {/* Main Headers */}
            <View style={[styles.tableRow, styles.tableHeader]}>
              {[
                { title: '', span: 2 },
                { title: 'DUE SALARY', span: 6 },
                { title: 'DRAWN SALARY', span: 6 },
                { title: 'DIFFERENCE', span: 5 },
                { title: 'PROF. TAX', span: 3 },
                { title: '', span: 1 },
              ].map((header, index) => (
                <View key={index} style={[styles.tableCell, { flex: header.span }]}>
                  <Text style={styles.tableCellHeader}>{header.title}</Text>
                </View>
              ))}
            </View>
            {/* Column Headers */}
            <View style={[styles.tableRow, styles.tableSubHeader]}>
              {[
                'Sr.No.', 'Month', 'Basic Pay', '%DA', 'DA', 'HRA', 'TRA', 'Total',
                'Basic Pay', '%DA', 'DA', 'HRA', 'TRA', 'Total',
                'Basic Pay', 'DA', 'HRA', 'TRA', 'Total',
                'PTDue', 'PTDrawn', 'PTRec', 'Net'
              ].map((header, index) => (
                <View key={index} style={[
                  index === 0 || index === 3 || index === 9 
                    ? styles.tableCellSrNo 
                    : index === 1 
                      ? styles.tableCellCustomWidth 
                      : styles.tableCell
                ]}>
                  <Text style={styles.tableCellSubHeader}>{header}</Text>
                </View>
              ))}
            </View>
            {/* Subheader with numbers */}
            <View style={[styles.tableRow, styles.tableSubHeader]}>
              {Array.from({ length: 23 }).map((_, index) => (
                <View key={index} style={[
                  index === 0 || index === 3 || index === 9 
                    ? styles.tableCellSrNo 
                    : index === 1 
                      ? styles.tableCellCustomWidth 
                      : styles.tableCell
                ]}>
                  <Text>{index + 1}</Text>
                </View>
              ))}
            </View>
            {/* Table Body */}
            {result.slice(0, totalPages * itemsPerPage).map((row, rowIndex) => {
              const pageIndex = Math.floor(rowIndex / itemsPerPage);
              if (pageIndex >= totalPages) return null;
              return (
                <View key={rowIndex} style={styles.tableRow}>
                  <View style={styles.tableCellSrNo}>
                    <Text>{pageIndex * itemsPerPage + (rowIndex % itemsPerPage) + 1}</Text>
                  </View>
                  {row.map((cell, cellIndex) => (
                    <View key={cellIndex} style={[
                      cellIndex === 2 || cellIndex === 8 
                        ? styles.tableCellSrNo 
                        : cellIndex === 0 
                          ? styles.tableCellCustomWidth 
                          : styles.tableCell
                    ]}>
                      <Text>{cell}</Text>
                    </View>
                  ))}
                </View>
              );
            })}
          </View>

          {/* Footer Section */}
          <View style={styles.footer}>
          <Text style={styles.dateText}>
            Generated on: {new Date().toLocaleDateString("en-GB")}
          </Text>
            <Text style={styles.Himanshu}>Himanshu Salary Corner</Text>
            <Text style={styles.pageNumber}>
              Page {pageIndex + 1} of {totalPages}
            </Text>
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default PureDaArrearsPDF;
